var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6809",
    "data-name": "Groupe 6809",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.553,
    height: 16,
    viewBox: "0 0 20.553 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 2.756,
    cy: 2.756,
    r: 2.756,
    transform: "translate(7.521 5.244)",
    fill: "#cbc9c9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9637",
    "data-name": "Trac\\xE9 9637",
    d: "M19.926,62.5a11.337,11.337,0,0,0-9.649-5.79A11.337,11.337,0,0,0,.628,62.5a4.2,4.2,0,0,0,0,4.419,11.337,11.337,0,0,0,9.649,5.79,11.337,11.337,0,0,0,9.649-5.79A4.2,4.2,0,0,0,19.926,62.5ZM10.277,69.85a5.136,5.136,0,1,1,5.136-5.136A5.136,5.136,0,0,1,10.277,69.85Z",
    transform: "translate(0 -56.714)",
    fill: "#cbc9c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/Eyes.7a22bda6707c81fa844d499698da99de.svg";
export { ForwardRef as ReactComponent };